<template>
  <div>
    <TeJobFrontendCover />

    <TeJobAbout>
      <template #title>
        フロントエンド
      </template>
      <template #content>
        <p class="co-display-10 mb-3 text-co-gray-500">
          jQueryを中心とした学習プログラムにおいて
          <br class="hidden md:block">
          受講生の「わからない」をリモートにてサポートしていただきます。
          <br class="hidden md:block">
          あなたのスキルを受講生の成長に活かしてみませんか？
        </p>
        <a href="/job">
          テックアカデミーのメンターについて
        </a>
      </template>
    </TeJobAbout>

    <TeJobTarget />

    <TeJobMessage>
      <template #mentoringText>
        1回30分のビデオチャットで受講生からの相談や質問に答えていただきます。
        <br class="hidden md:block">
        時にはペアプログラミングなどのサポートをしていただきます。
        <br class="hidden md:block">
        マンツーマンメンタリングはカリキュラムやチャットで解決できなかった課題を確実に解消させる取り組みです。
      </template>
      <template #chatsupportText>
        15時〜23時の間のシフト制で、
      </template>
    </TeJobMessage>

    <TeJobWorkStyle />

    <section
      id="pickup-mentor"
      class="co-bg-striped text-center"
    >
      <div class="co-container-lg px-4 py-20">
        <h2 class="co-heading-2-caption">
          メンター紹介
        </h2>
        <h3 class="co-display-12 mb-[3.25rem] text-left leading-base text-co-gray-600 md:text-center">
          テックアカデミーではメンターが多数在籍しています。
          <br class="hidden md:block">
          現在活躍している一部のメンターをご紹介。
        </h3>
        <div class="flex flex-wrap justify-center text-left">
          <div class="basis-full md:basis-8/12">
            <div class="flex flex-wrap">
              <div class="basis-full px-4 text-center md:basis-1/4">
                <img
                  src="~/assets/images/Te/TeJob/Mentor/mentor-hachiya.jpg"
                  class="mx-auto mb-5 w-1/4 rounded-full md:mb-0 md:w-full"
                  alt="Satoshi Hachiya"
                  loading="lazy"
                >
              </div>
              <div class="basis-full px-0 text-left md:basis-3/4 md:px-4">
                <h4 class="co-display-10 text-center md:text-left">
                  Satoshi Hachiya
                </h4>
                <p>
                  Javaプログラマー・NW保守を経て、現在はウェブサイトの運用保守チームで開発サポートと分析業務に携わっています。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <TeJobMentorSlider />

    <!-- スキル -->
    <section
      id="skill"
      class="co-bg-striped"
    >
      <div class="co-container-lg px-4 pb-[3.75rem] pt-20 lg:pb-10">
        <h2 class="co-heading-2">
          フロントエンドメンターに必要なスキル
        </h2>
        <div class="grid grid-cols-1 justify-center gap-9 lg:grid-cols-2 lg:gap-x-8 lg:gap-y-10">
          <TeJobSkill>
            <template #icon>
              <FontAwesomeIcon
                :icon="faHtml5"
                class="size-11 text-[#e44d26]"
              />
            </template>
            <template #title>
              HTML/CSS3
            </template>
            <template #description>
              HTML/CSS の業務経験（2年以上）
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <img
                class=""
                src="~/assets/images/Te/TeJob/Skill/curriculum-js.png"
                alt="jQuery/JavaScript"
                width="48"
                loading="lazy"
              >
            </template>
            <template #title>
              jQuery/JavaScriptの業務経験
            </template>
            <template #description>
              jQuery, JavaScriptの業務経験（2年以上）
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <FontAwesomeIcon
                :icon="faArrowRightArrowLeft"
                class="h-11 w-9 text-co-success-500"
              />
            </template>
            <template #title>
              Web APIを利用したサービス開発
            </template>
            <template #description>
              Web APIを利用したサービス開発の経験
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeJob/Skill/curriculum-firebase.png"
                alt="Firebase"
                width="48"
                loading="lazy"
              >
            </template>
            <template #title>
              Firebase
            </template>
            <template #description>
              Firebaseを利用したWebサービス開発が可能な方
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeJob/Skill/curriculum-bootstrap.png"
                alt="Bootstrap"
                width="48"
                loading="lazy"
              >
            </template>
            <template #title>
              Bootstrapを利用したレイアウトの経験
            </template>
            <template #description>
              Bootstrapの基礎知識とレスポンシブサイト構築の知識
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <FontAwesomeIcon
                :icon="faCode"
                class="h-11 w-9 text-[#5e98a9]"
              />
            </template>
            <template #title>
              最近のフロントエンド技術
            </template>
            <template #description>
              最近のフロントエンド技術（フレームワークなど）について詳しい方
            </template>
          </TeJobSkill>
        </div>
      </div>
    </section>

    <TeJobFlow />

    <TeJobEntry course-name-path="frontend" />
  </div>
</template>

<script setup lang="ts">
import { metaTags } from '~/utility/constants/metaTags'

import TeJobFrontendCover from '~/components/Te/TeJob/Frontend/TeJobFrontendCover.vue'
import TeJobAbout from '~/components/Te/TeJob/TeJobAbout.vue'
import TeJobTarget from '~/components/Te/TeJob/TeJobTarget.vue'
import TeJobMessage from '~/components/Te/TeJob/TeJobMessage.vue'
import TeJobWorkStyle from '~/components/Te/TeJob/TeJobWorkStyle.vue'
import TeJobMentor from '~/components/Te/TeJob/TeJobMentor.vue'
import TeJobMentorSlider from '~/components/Te/TeJob/TeJobMentorSlider.vue'
import TeJobSkill from '~/components/Te/TeJob/TeJobSkill.vue'
import TeJobFlow from '~/components/Te/TeJob/TeJobFlow.vue'
import TeJobEntry from '~/components/Te/TeJob/TeJobEntry.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faHtml5 } from '@awesome.me/kit-65d95819ce/icons/classic/brands'
import { faArrowRightArrowLeft, faCode } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

useJobHead()

useHead({
  title: 'フロントエンド講師（メンター）募集 |テックアカデミー',
  meta: [
    ...metaTags({
      description:
        '受講生をサポートするフロントエンドメンター（講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のプログラミングスキルを活用したい場合は、まずはお気軽にご応募ください。 ',
      twitterTitle: 'フロントエンド講師（メンター）募集',
      twitterDescription:
        '受講生をサポートするフロントエンドメンター（講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のプログラミングスキルを活用したい場合は、まずはお気軽にご応募ください。 ',
      twitterImage: '/_nuxt/ogp/og-image-mentor-frontend.jpg',
      ogTitle: 'フロントエンド講師（メンター）募集',
      ogDescription:
        '受講生をサポートするフロントエンドメンター（講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のプログラミングスキルを活用したい場合は、まずはお気軽にご応募ください。 ',
      ogUrl: '/job/frontend',
      ogImage: '/_nuxt/ogp/og-image-mentor-frontend.jpg',
    }),
  ],
})
</script>
